import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  Input,
  OnInit,
} from '@angular/core';
import {
  TuiButtonModule,
  TuiDialogService,
  TuiGroupModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/core';
import { TuiInputModule } from '@taiga-ui/kit';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CoordsForm } from '@shared/components/catalogs/client-form/client-form.component';
import { catchError, of, Subject, switchMap, tap } from 'rxjs';
import {
  LocationSelectComponent,
  LocationSelectInputData,
  LocationSelectOutputData,
} from '@shared/components/google-map/location-select/location-select.component';
import { PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { joinLatLong } from '@shared/utils/coords';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlertService } from '@shared/services/alert.service';

@Component({
  selector: 'app-client-address-with-coordinates',
  standalone: true,
  imports: [
    TuiButtonModule,
    TuiGroupModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    ReactiveFormsModule,
  ],
  templateUrl: './client-address-with-coordinates.component.html',
  styleUrl: './client-address-with-coordinates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientAddressWithCoordinatesComponent implements OnInit {
  @Input({ required: true }) address: FormGroup<CoordsForm>;

  selectLocation$ = new Subject<void>();

  constructor(
    private readonly dialogs: TuiDialogService,
    private readonly alert: AlertService,
    private readonly destroyRef: DestroyRef,
  ) {}

  onLocationSelect() {
    this.selectLocation$
      .pipe(
        switchMap(() => {
          const data: LocationSelectInputData = {
            coords: this.address.controls.latLong.getRawValue(),
          };
          return this.dialogs
            .open<LocationSelectOutputData>(
              new PolymorpheusComponent(LocationSelectComponent),
              {
                size: 'auto',
                data,
              },
            )
            .pipe(
              tap(({ latLng, address }) => {
                const latLong = joinLatLong(
                  latLng.lat.toString(),
                  latLng.lng.toString(),
                );

                this.address.patchValue({ address, latLong });
              }),
            );
        }),
        catchError(() => {
          this.alert.showError();
          return of(null);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  ngOnInit() {
    this.onLocationSelect();
  }
}
